// useDocuments — read-only document lookup BY payment reference
// (GET /v1/documents?payment_ref=&company_id=).
//
// There is no company-wide document feed yet (backend lists by payment_ref
// only), so this hook is disabled until a payment_ref is supplied.
import { useQuery } from "@tanstack/react-query";

import { listDocuments, type ListDocumentsParams } from "@/api/documents";
import { useAuth } from "@/store/auth";

export function useDocuments(params: ListDocumentsParams | null) {
  const status = useAuth((s) => s.status);
  const paymentRef = params?.payment_ref ?? "";
  return useQuery({
    queryKey: ["documents", params],
    queryFn: () => listDocuments(params!),
    enabled: status === "authenticated" && paymentRef.trim() !== "",
    staleTime: 30_000,
  });
}
